<!--二段页面布局-->
<template>
  <div class="page_layout_slot_two" >


    <!--条件部分-->
    <div class="content_up" >
      <!--标题-->
      <div class="title_bar" >
        <span class="title" >{{title_1}}</span>
        <span v-show="show_pull_down" @click="pull_down" style=" color: #074D95;font-size: 12px;
        cursor: pointer; position: relative; top: 0px; margin-left: 10px;" >展开<i class="el-icon-arrow-down" ></i></span>
      </div>

      <!--内容-->
      <div class="content_slot" >
        <slot name="content_up" ></slot>
      </div>
    </div>

    <!--内容部分-->
    <div class="content_down" >

      <!--标题-->
      <div class="title_bar" >
        <span  class="title"  >{{title_2}}</span>
      </div>

      <!--内容-->
      <div class="content_slot" >
        <slot name="content_down" ></slot>
      </div>

    </div>

  </div>
</template>

<script>
export default {
  name: "page_layout_slot_two",
  props:{
    show_pull_down:{
      type:Boolean,
      default:() => {
        return false
      }
    },
    title_1:{
      type:String,
      default:'查询条件'
    },
    title_2:{
      type:String,
      default:'查询结果'
    }
  },
  methods:{
    pull_down(){
      this.$emit('pull_down')
    }
  }
}
</script>

<style lang="scss">
.page_layout_slot_two{
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;

  .content_up{
    /*min-height: 100px;*/
  }

  .content_down{
    flex: 1;
  }

  .content_slot{
    width: 100%;
    height: calc(100% - 40px);
  }

  .title_bar{
    width: 100%;
    height: 40px;
    line-height: 40px;
    border-left: 10px solid #00955b;
    background-color: #E5F4EE;

    padding-left: 10px;

    .title{
      color: #00955b;
      font-size: 16px;
      font-weight: bold;
    }
  }

}

</style>



// WEBPACK FOOTER //
// src/components/yxgl_system/page_layout_slot_two.vue